import { render, staticRenderFns } from "./OrderDevices.vue?vue&type=template&id=724f9ea9&"
import script from "./OrderDevices.vue?vue&type=script&lang=js&"
export * from "./OrderDevices.vue?vue&type=script&lang=js&"
import style0 from "./OrderDevices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports